import { render, staticRenderFns } from "./EmailConfirmationBanner.vue?vue&type=template&id=48c2320c"
import script from "./EmailConfirmationBanner.vue?vue&type=script&lang=js"
export * from "./EmailConfirmationBanner.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports